import { Component, Inject, OnInit } from '@angular/core';
import { ApiService } from '../../shared/api.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ClienteNumeroModalComponent } from '../cliente-numero-modal/cliente-numero-modal.component';


@Component({
  selector: 'app-modal-callejero-numero-clientes',
  templateUrl: './modal-callejero-numero-clientes.component.html',
  styleUrls: ['./modal-callejero-numero-clientes.component.scss']
})
export class ModalCallejeroNumeroClientesComponent implements OnInit {

  comunas: any[] = [];
  calles: any[] = [];
  numeros: any[] = [];
  casas: any[] = [];
  cliente: any[] = [];

  response: any;

  filteredComunas: any[] = [];
  filteredCalles: any[] = [];
  filteredNumeros: any[] = [];
  filteredCasas: any[] = [];

  selectedComuna: string = '';
  selectedCalle: string = '';
  selectedNumero: string = '';
  selectedCasa: string = '';

  selectedComunaId: number | null = null;
  selectedCalleId: number | null = null;
  selectedNumeroId: number | null = null;

  showDropdownComuna: boolean = false;
  showDropdownCalle: boolean = false;
  showDropdownNumero: boolean = false;
  showDropdownCasa: boolean = false;

  showMessageComuna: boolean = false;
  showMessageCalle: boolean = false;
  showMessageNumero: boolean = false;
  showMessageCasa: boolean = false;

  isInputFocusedComuna: boolean = false;
  isInputFocusedCalle: boolean = false;
  isInputFocusedNumero: boolean = false;
  isInputFocusedCasa: boolean = false;


  constructor(
    private callejeroService: ApiService,
    public dialogRef: MatDialogRef<ModalCallejeroNumeroClientesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) {}


  onInputChange(query: string) {
    this.selectedComuna = query;
    if (this.selectedComuna.length >= 3) {
      this.showMessageComuna = false; 
      this.searchComuna(query);
    } else {
      this.filteredComunas = [];
      this.showMessageComuna = true;
    }
    this.updateDropdownVisibility('comuna');
  }

  onCalleInputChange(query: string) {
    this.selectedCalle = query;
    if (this.selectedCalle.length >= 3) {
      this.showMessageCalle = false; 
      this.searchCalle(query);
    } else {
      this.filteredCalles = [];
      this.showMessageCalle = true;
    }
    this.updateDropdownVisibility('calle');
  }

  onNumeroInputChange(query: string) {
    this.selectedNumero = query;
    if (this.selectedNumero.length >= 1) {
      this.showMessageNumero = false;
      this.searchNumeros(query);
    } else {
      this.filteredNumeros = [];
      this.showMessageNumero = true;
    }
    this.updateDropdownVisibility('numero');
  }

  onCasaInputChange(query: string) {
    this.selectedCasa = query;
    if (this.selectedCasa.length >= 0) {
      this.showMessageCasa = false;
      this.searchCasas(query);
    } else {
      this.filteredCasas = [];
      this.showMessageCasa = true;
    }
    this.updateDropdownVisibility('casa');
  }

  onFocus(field: string) {
    if (field === 'comuna') {
      this.isInputFocusedComuna = true;
      this.showMessageComuna = this.selectedComuna.length < 3;
    } else if (field === 'calle') {
      this.isInputFocusedCalle = true;
      this.showMessageCalle = this.selectedCalle.length < 3 && !this.selectedComuna;
    } else if (field === 'numero') {
      this.isInputFocusedNumero = true;
      this.showMessageNumero = this.selectedNumero.length < 1 && !this.selectedComuna && !this.selectedCalle;
    } else if (field === 'casa') {
      this.isInputFocusedCasa = true;
      this.showMessageCasa = this.selectedCasa.length < 0 && !this.selectedComuna && !this.selectedCalle && !this.selectedNumero;
    }
    this.updateDropdownVisibility(field);
  }

  onBlur(field: string) {
    setTimeout(() => {
      if (field === 'comuna') {
        this.showDropdownComuna = false;
        this.isInputFocusedComuna = false;
        this.showMessageComuna = false;
      } else if (field === 'calle') {
        this.showDropdownCalle = false;
        this.isInputFocusedCalle = false;
        this.showMessageCalle = false;
      } else if (field === 'numero') {
        this.showDropdownNumero = false;
        this.isInputFocusedNumero = false;
        this.showMessageNumero = false;
      } else if (field === 'casa') {
        this.showDropdownCasa = false;
        this.isInputFocusedCasa = false;
        this.showMessageCasa = false;
      }
    }, 200);
  }

  updateDropdownVisibility(field: string) {
    if (field === 'comuna') {
      this.showDropdownComuna = this.selectedComuna.length >= 3 || this.filteredComunas.length > 0;
    } else if (field === 'calle') {
      this.showDropdownCalle = this.selectedCalle.length >= 3 || this.filteredCalles.length > 0;
    } else if (field === 'numero') {
      this.showDropdownNumero = this.selectedNumero.length >= 1 || this.filteredNumeros.length > 0;
    } else if (field === 'casa') {
      this.showDropdownCasa = this.selectedCasa.length >= 0 || this.filteredCasas.length > 0;
    }
  }

  
  searchComuna(query: string) {
    this.callejeroService.searchComunas(query).subscribe(
      res => {
        this.response = res;
        this.comunas = res.data;

        this.filteredComunas = this.comunas.filter(comuna =>
          comuna.nombre.toLowerCase().includes(query.toLowerCase())
        );

        const lastFilteredComunas = this.filteredComunas;
        this.selectedComunaId =  lastFilteredComunas[0].id
      },
      err => {
        console.error('Error fetching comunas:', err);
      }
    );
  }

  searchCalle(calleNombre: string) {
    if (this.selectedComunaId && calleNombre.length > 0) {
      this.callejeroService.searchCalle(this.selectedComunaId, calleNombre).subscribe(
        res => {
          this.response = res;
          this.calles = res.data;
  
          this.filteredCalles = this.calles.filter(calle =>
            calle.nombre.toLowerCase().includes(calleNombre.toLowerCase())
          );
        },
        err => {
          console.error('Error searching calle:', err);
        }
      );
    }
  }

  searchNumeros(nombre: string) {
    if (this.selectedCalleId && nombre.length > 0) {
      this.callejeroService.searchNumero(this.selectedCalleId, nombre).subscribe(
        res => {
          this.response = res;
          this.numeros = res.data;

          this.filteredNumeros = this.numeros.filter(numero =>
            numero.nombre.toLowerCase().includes(nombre.toLowerCase())
          );
        },
        err => {
          console.error('Error searching calle:', err);
        }
      );
    }
  }

  searchCasas(adicional: string) {
    if (this.selectedNumero && adicional.length >= 0) {
      this.callejeroService.searchAdicional(this.selectedCalleId, this.selectedNumero, adicional ).subscribe(
        res => {
          this.response = res;
          this.casas = res.data;

          this.filteredCasas = this.casas.filter(casa =>
            casa.nombre.toLowerCase().includes(adicional.toLowerCase())
          );
        },
        err => {
          console.error('Error searching calle:', err);
        }
      );
    }
  }
/*
  searchCliente() {
    this.callejeroService.searchCliente(this.selectedCalleId,  this.selectedNumero , this.selectedCasa )
    .subscribe(res => {
        this.response = res;
        this.cliente = res.data;

        if (this.cliente && this.cliente.length > 0) {
          this.dialog.open(ClienteNumeroModalComponent, {
            data: { cliente: this.cliente[0] }
          });
        } else {
          this.dialog.open(ClienteNumeroModalComponent, {
            data: { cliente: null }
          });
        }

      },
      err => {
        console.error('Error searching calle:', err);
      }
    );
  }
*/
  searchCliente() {
    this.callejeroService.searchCliente(this.selectedCalleId, this.selectedNumero, this.selectedCasa)
      .subscribe(res => {
        const cliente = res.data?.length > 0 ? res.data[0] : null;
        const childDialogRef = this.dialog.open(ClienteNumeroModalComponent, {
          data: { cliente }
        });

        childDialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.dialogRef.close(result);
          }
        });
      },
      err => {
        console.error('Error searching cliente:', err);
      });
  }

  selectComuna(comuna: any) {
    this.selectedComuna = comuna.nombre;
    this.filteredComunas = [];
    this.showDropdownComuna = false;
    this.showMessageComuna = false;
    this.isInputFocusedComuna = false;
  }

  selectCalle(calle: any) {
    this.selectedCalle = calle.nombre;
    this.selectedCalleId = calle.id;
    this.filteredCalles = [];
    this.showDropdownCalle = false;
    this.showMessageCalle = false;
    this.isInputFocusedCalle = false;
  }

  selectNumero(numero: any) {
    this.selectedNumero = numero.nombre;
    this.filteredNumeros = [];
    this.showDropdownNumero = false;
    this.showMessageNumero = false;
    this.isInputFocusedNumero = false;
  }

  selectCasa(casa: any) {
    this.selectedCasa = casa.nombre;
    this.searchCasas("");
    this.filteredCasas = [];
    this.showDropdownCasa = false;
    this.showMessageCasa = false;
    this.isInputFocusedCasa = false;
  }

  ngOnInit() {
  }

  cerrarModalPadre() {
    if (this.data.parentDialogRef) {
        this.data.parentDialogRef.close();
    }
    this.dialogRef.close('Cierre desde modal hijo');
  }

  cerrarModal() {
    this.dialogRef.close('childClosed');
  }

}